import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showTokenExpiredAlert, getConfig, authHeader, getCustId, isApiSuccess } from "utils";

// GET subscriber/getSubscriberCharges/{custId}
// NOTE: rows come back in `data` (not `dataList`) for this endpoint.
export const chargesList = createAsyncThunk('charges/list', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `subscriber/getSubscriberCharges/${getCustId()}`,
            headers: authHeader()
        })
        return res
    } catch (error) {
        return error.response
    }
})

const charges = createSlice({
    name: 'charges',
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(chargesList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(chargesList.fulfilled, (state, action) => {
            state.loading = false;
            if (isApiSuccess(action?.payload)) {
                state.list = action.payload.data.data || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else {
                state.list = []
            }
        });
        builder.addCase(chargesList.rejected, (state) => {
            state.loading = false;
        });
    }
})

export default charges.reducer;
